import { useQuery } from '@tanstack/react-query';
import { PROFILE_IMMIGRATION_DOC_DETAILS_KEY } from '../../utils/constants/queryKeys';
import {
  getProfileImmigrationDocDetails,
  IProfileImmigrationDocDetailsParams,
} from '../services/fn-api/ImmigrationDocuments';

export const useGetProfileImmigrationDocDetails = (params: IProfileImmigrationDocDetailsParams = {}) => {
  return useQuery({
    queryKey: [PROFILE_IMMIGRATION_DOC_DETAILS_KEY, params.beneId, params.dependentId, params.includeDocument],
    queryFn: () => getProfileImmigrationDocDetails(params),
    enabled: Boolean(params.beneId || params.dependentId),
  });
};
